import type { ErrorCodes } from 'owa-error-codes';
import { type OlkUserErrorCodes } from 'owa-error-codes';
import type { TraceErrorObject } from 'owa-analytics-types';

/**
 * Determines if the given error represents a user error and returns the appropriate error code.
 * @param error The error object to analyze
 * @returns The appropriate user error code if this is a user error, undefined otherwise
 */
export default function getUserErrorCode(error: TraceErrorObject): ErrorCodes | undefined {
    if (error.responseCode === 'ErrorOrganizationAccessBlocked') {
        return '41_0001';
    }

    if (error.responseCode === 'ErrorNameResolutionNoMailbox') {
        return '41_0002';
    }

    return undefined;
}
